import { CallContent } from "../../../Components/CallApp/CallApp";

export const InfluencerCallContent: CallContent[] = [
  {
    Contact: "Woodpecker",
    date: "Wed 3 April 2024",
    time: "4:09 PM",
    type: "missed",
  },
  {
    Contact: "Woodpecker",
    date: "Wed 3 April 2024",
    time: "4:09 PM",
    type: "missed",
  },
  {
    Contact: "Woodpecker",
    date: "Wed 3 April 2024",
    time: "4:03 PM",
    type: "missed",
  },
  {
    Contact: "Salamander",
    date: "Wed 3 April 2024",
    time: "1:07 PM - 16 min",
    type: "outgoing",
  },
  {
    Contact: "Woodpecker",
    date: "Wed 3 April 2024",
    time: "12:49 PM",
    type: "missed",
  },
  {
    Contact: "Woodpecker",
    date: "Wed 3 April 2024",
    time: "12:48 PM",
    type: "missed",
  },

  {
    Contact: "Salamander",
    date: "Wed 3 April 2024",
    time: "10:43 AM",
    type: "missed",
  },
  {
    Contact: "Salamander",
    date: "Wed 3 April 2024",
    time: "10:24 AM",
    type: "missed",
  },
  {
    Contact: "Salamander",
    date: "Wed 3 April 2024",
    time: "10:23 AM",
    type: "missed",
  },
];
